import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    SelectInput,
    BooleanInput,
    required,
    TopToolbar,
    ListButton
} from 'react-admin';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Box,
    Avatar,
    Divider
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const CreateActions = () => (
    <TopToolbar>
        <ListButton to="/leghe" />
    </TopToolbar>
);

export const Tbl_legaCreate = props => (
    <Create {...props} actions={<CreateActions />} title="Crea Nuova Lega" redirect="/leghe">
        <SimpleForm>
            {/* Header */}
            <Box sx={{ mb: 3 }}>
                <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                    <CardContent>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                                    <AddCircleIcon sx={{ fontSize: 32, color: 'white' }} />
                                </Avatar>
                            </Grid>
                            <Grid item xs>
                                <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 1 }}>
                                    Crea Nuova Lega
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                                    Compila i campi per creare una nuova lega sportiva
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>

            {/* Informazioni Principali */}
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <EmojiEventsIcon color="primary" />
                        Informazioni Principali
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                source="nome"
                                label="Nome Lega"
                                validate={required()}
                                fullWidth
                                helperText="Inserisci il nome della lega"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SelectInput
                                source="sportId"
                                label="Sport"
                                validate={required()}
                                choices={[
                                    { id: 1, name: 'Calcio' },
                                    { id: 2, name: 'Basket' },
                                    { id: 3, name: 'Pallavolo' },
                                    { id: 4, name: 'Tennis' },
                                    { id: 5, name: 'Padel' }
                                ]}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextInput
                                source="note"
                                label="Note"
                                multiline
                                rows={4}
                                fullWidth
                                helperText="Note aggiuntive sulla lega (opzionale)"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <NumberInput
                                source="ordinamento"
                                label="Ordinamento"
                                defaultValue={0}
                                fullWidth
                                helperText="Posizione nell'elenco (0 = primo)"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Configurazioni */}
            <Card>
                <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Configurazioni
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <BooleanInput
                                source="flAttivo"
                                label="Lega Attiva"
                                defaultValue={true}
                                helperText="La lega è attualmente attiva"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <BooleanInput
                                source="flVisibile"
                                label="Lega Visibile"
                                defaultValue={true}
                                helperText="La lega è visibile pubblicamente"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <BooleanInput
                                source="flAnnullato"
                                label="Lega Annullata"
                                defaultValue={false}
                                helperText="Segna la lega come annullata"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </SimpleForm>
    </Create>
);
